import { useTranslation } from "../contexts/LocaleContext";

export function HeroDashboardMockup() {
    const { t } = useTranslation();
    return (
        <div className="lg:w-1/2 w-full max-w-lg lg:max-w-none"  >
            <div className="relative flex justify-center items-center py-10">
                <div className="transition-all duration-1000 transform opacity-100 translate-y-0 relative">
                    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-blue-400/20 blur-[100px] rounded-full pointer-events-none" />
                    <div className="relative w-[320px] h-[640px] bg-white border-[10px] border-slate-900 rounded-[3rem] shadow-2xl overflow-hidden z-10 animate-float">
                        <div className="absolute top-[-2px] left-1/2 transform -translate-x-1/2 w-32 h-7 bg-slate-900 rounded-b-xl z-20" />
                        <div className="w-full h-full bg-slate-50 relative pt-14 px-4 flex flex-col">
                            <div className="w-full h-5 mb-2 flex justify-between items-center px-2 opacity-50">
                                <span className="text-[10px] font-bold text-slate-900">
                                    9:41
                                </span>
                                <div className="flex gap-1">
                                    <div className="w-4 h-2.5 bg-slate-900 rounded-sm" />
                                </div>
                            </div>
                            <div className="flex-1 space-y-4 overflow-y-auto">
                                {/* Header */}
                                <div className="bg-white rounded-xl p-3 shadow-sm border border-slate-100">
                                    <div className="flex items-center gap-2 mb-2">
                                        <div className="w-8 h-8 rounded-lg bg-slate-900 flex items-center justify-center">
                                            <svg data-prefix="fas" data-icon="envelope" className="svg-inline--fa fa-envelope text-blue-500 text-sm" role="img" viewBox="0 0 512 512" aria-hidden="true">
                                                <path fill="#fff" d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z" />
                                            </svg>
                                        </div>
                                        <span className="text-sm font-bold text-slate-900">{t("hero.new_email")}</span>
                                    </div>
                                </div>

                                {/* 邮件卡片 */}
                                <div
                                    className="opacity-0 animate-slide-up-fade"
                                    style={{
                                        animationDelay: "0.3s",
                                        animationFillMode: "forwards",
                                    }}
                                >
                                    <div className="bg-white rounded-xl p-4 shadow-sm border border-slate-100">
                                        <div className="flex items-center gap-2 mb-3">
                                            <span className="text-xs text-slate-400 w-12">{t("hero.to")}</span>
                                            <div className="flex-1 bg-slate-50 rounded-lg px-3 py-2">
                                                <span className="text-xs text-slate-600">user@example.com</span>
                                            </div>
                                        </div>
                                        <div className="flex items-center gap-2 mb-3">
                                            <span className="text-xs text-slate-400 w-12">{t("hero.subject")}</span>
                                            <div className="flex-1 bg-slate-50 rounded-lg px-3 py-2">
                                                <span className="text-xs text-slate-600">{t("hero.subject_placeholder")}</span>
                                            </div>
                                        </div>
                                        <div className="w-full   bg-slate-50 rounded-lg p-2">
                                            <div className="flex gap-1 mb-2">
                                                <div className="w-8 h-1 bg-slate-200 rounded"></div>
                                                <div className="w-4 h-1 bg-slate-900 rounded"></div>
                                            </div>
                                            <span className="text-xs text-slate-400">{t("hero.content_preview")}</span>
                                        </div>

                                    </div>
                                </div>

                                {/* 发送状态 */}
                                <div
                                    className="opacity-0 animate-slide-up-fade"
                                    style={{
                                        animationDelay: "1.2s",
                                        animationFillMode: "forwards",
                                    }}
                                >
                                    <div className="bg-white rounded-xl p-4 shadow-lg border border-slate-100">
                                        <div className="flex items-center justify-between">
                                            <div className="flex items-center gap-3">

                                                <div>
                                                    <span className="text-sm font-bold text-slate-900">{t("hero.send_success")}</span>
                                                    <p className="text-xs text-slate-400 leading-tight">{t("hero.delivered", { n: 3 })}</p>
                                                </div>
                                            </div>
                                            <div className="text-right">
                                                <span className="text-xs font-bold text-green-600">{t("hero.time_ago", { n: 1 })}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* 底部发送栏 */}
                            <div className="absolute bottom-6 left-4 right-4 h-14 bg-white rounded-full shadow-lg border border-slate-100 flex items-center px-5 justify-between z-20">
                                <div className="flex items-center gap-2 text-slate-400">
                                    <svg data-prefix="fas" data-icon="plus" className="svg-inline--fa fa-plus text-xs" role="img" viewBox="0 448 512" aria-hidden="true">
                                        <path fill="currentColor" d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z" />
                                    </svg>
                                    <span className="text-sm">{t("hero.new_mail")}</span>
                                </div>
                                <div className="w-10 h-10 bg-slate-900 rounded-full flex items-center justify-center text-white text-sm shadow-md hover:scale-105 transition-transform cursor-pointer">
                                    <svg data-prefix="fas" data-icon="envelope" className="svg-inline--fa fa-envelope" role="img" viewBox="0 512 512" aria-hidden="true">
                                        <path fill="#fff" d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z" />
                                    </svg>
                                </div>
                            </div>
                            <div className="w-32 h-1 bg-slate-300 rounded-full mx-auto absolute bottom-2 left-1/2 transform -translate-x-1/2" />
                        </div>
                    </div>
                    {/* 成功提示卡片 */}
                    <div
                        className="absolute top-[15%] -right-16 z-20 hidden md:block opacity-0 animate-slide-in-right"
                        style={{ animationDelay: "2s", animationFillMode: "forwards" }}
                    >
                        <div className="bg-white p-4 rounded-xl shadow-xl flex items-center gap-3 border border-slate-100">
                            <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center text-green-500">
                                <svg data-prefix="fas" data-icon="check-circle" className="svg-inline--fa fa-check-circle text-xl" role="img" viewBox="0 0 512 512" aria-hidden="true">
                                    <path fill="currentColor" d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z" />
                                </svg>
                            </div>
                            <div></div>
                            <div className="text-sm font-bold text-slate-900">{t("hero.send_success")}</div>
                        </div>
                    </div>
                </div>
            </div>
            <style
                dangerouslySetInnerHTML={{
                    __html:
                        `
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        @keyframes slide-up-fade {
          0% { opacity: 0; transform: translateY(20px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        @keyframes slide-in-right {
          0% { opacity: 0; transform: translateX(20px); }
          100% { opacity: 1; transform: translateX(0); }
        }
        .animate-float {
          animation: float 6s ease-in-out infinite;
        }
        .animate-slide-up-fade {
          animation: slide-up-fade 0.6s ease-out forwards;
        }
        .animate-slide-in-right {
          animation: slide-in-right 0.6s ease-out forwards;
        }
      `,
                }}
            />
        </div>
    );
}

export default HeroDashboardMockup;
